import React, { useEffect, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import api from '../../../utils/api';
import { useToast } from '../../../context/ToastContext';

export default function AddSectionsToBatch() {
  const navigate = useNavigate();
  const { id: batchId } = useParams();
  const { state } = useLocation();
  const programId = state?.programId;
  const { showToast } = useToast();

  const [sections, setSections] = useState([]);
  const [form, setForm] = useState({
    programSectionsId: '',
    startDate: '',
    endDate: '',
  });
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const fetchSections = async () => {
      try {
        if (!programId) return;
        const data = await api.getSectionsByProgram({ programId });
        setSections(data);
      } catch (error) {
        console.error('Failed to load program sections', error);
        showToast('Gagal memuat tahapan program.', 'danger');
      } finally {
        setLoading(false);
      }
    };
    fetchSections();
  }, [programId, showToast]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.programSectionsId) {
      showToast('Pilih section program terlebih dahulu.', 'danger');
      return;
    }
    setSubmitting(true);
    try {
      await api.addSectionsBatch({ batchId, ...form });
      showToast('Section berhasil ditambahkan ke batch!', 'success');
      navigate(`/program/${programId}`);
    } catch (error) {
      showToast('Gagal menambahkan section ke batch.', 'danger');
    } finally {
      setSubmitting(false);
    }
  };

  if (!programId) {
    return (
      <div className="container py-5 text-center" style={{ maxWidth: '720px' }}>
        <div className="alert alert-warning border-0 rounded-4 p-4 shadow-sm">
          <i className="bi bi-exclamation-triangle-fill fs-3 text-warning d-block mb-2"></i>
          <h5 className="fw-bold text-dark">Program ID Tidak Ditemukan</h5>
          <p className="text-muted small">Kembali ke halaman sebelumnya untuk mencoba lagi.</p>
          <button
            className="btn btn-primary rounded-pill px-4 mt-2"
            onClick={() => navigate(-1)}
          >
            <i className="bi bi-arrow-left me-2"></i> Kembali
          </button>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="text-center py-5 text-secondary small">
        <div className="spinner-border text-primary mb-3" role="status"></div>
        <div>Mengambil data sections program...</div>
      </div>
    );
  }

  return (
    <div className="container py-4" style={{ maxWidth: '720px' }}>
      {/* Back Button */}
      <div className="mb-3">
        <button
          type="button"
          className="btn btn-white btn-sm rounded-circle shadow-sm border bg-white text-dark d-inline-flex align-items-center justify-content-center"
          style={{ width: '38px', height: '38px' }}
          onClick={() => navigate(-1)}
        >
          <i className="bi bi-arrow-left fs-5"></i>
        </button>
      </div>

      {/* HEADER */}
      <div className="mb-4">
        <h3 className="fw-bold">Tambah Tahapan ke Batch</h3>
        <p className="text-muted">
          Pilih tahapan program dan tentukan tanggal pelaksanaan untuk batch ini.
        </p>
      </div>

      <div className="card border-0 shadow-sm rounded-4">
        <div className="card-body p-4">
          <form onSubmit={handleSubmit} className="row g-3">
            {/* Program Section Select */}
            <div className="col-12">
              <label className="form-label fw-semibold">
                Pilih Tahapan Program <span className="text-danger">*</span>
              </label>
              <select
                className="form-select rounded-3"
                name="programSectionsId"
                value={form.programSectionsId}
                onChange={handleChange}
                required
              >
                <option value="">-- Pilih Tahapan --</option>
                {sections.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.title}
                  </option>
                ))}
              </select>
              <small className="text-muted">
                Pilih tahapan program yang ingin dijalankan di batch ini.
              </small>
            </div>

            {/* Start Date */}
            <div className="col-md-6">
              <label className="form-label fw-semibold">Tanggal Mulai <span className="text-danger">*</span></label>
              <input
                type="date"
                name="startDate"
                className="form-control rounded-3"
                value={form.startDate}
                onChange={handleChange}
                required
              />
            </div>

            {/* End Date */}
            <div className="col-md-6">
              <label className="form-label fw-semibold">Tanggal Selesai <span className="text-danger">*</span></label>
              <input
                type="date"
                name="endDate"
                className="form-control rounded-3"
                value={form.endDate}
                onChange={handleChange}
                required
              />
            </div>

            {/* ACTION BUTTONS */}
            <div className="d-flex justify-content-end mt-4">
              <button
                type="button"
                className="btn btn-light rounded-pill me-2"
                onClick={() => navigate(-1)}
                disabled={submitting}
              >
                Batal
              </button>

              <button
                type="submit"
                className="btn btn-primary rounded-pill px-4"
                disabled={submitting}
              >
                {submitting ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Menyimpan...
                  </>
                ) : (
                  <>
                    <i className="bi bi-save me-2"></i> Simpan
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
